import { convert24HourTo12Hour } from '../utils/convert-24-hour-to-12-hour';
import { padNumberToLength } from '../utils/pad-number-to-length';
/**
 * Returns a numerical representation of the hour in 24-hour time: 0, 1, ... 23
 * @hidden
 */
export const getHour24Numeric = ({ offsetUtcDate }) => {
    return offsetUtcDate.getUTCHours();
};
/**
 * Returns a two-digit string representation of the hour in 24-hour time: 00, 01, ..., 23
 * @hidden
 */
export const getHour24TwoDigit = (params) => {
    const hour = getHour24Numeric(params);
    return padNumberToLength(hour, 2);
};
/**
 * Returns a numerical representation of the hour in 12-hour time: 1, 2, ..., 12
 * @hidden
 */
export const getHour12Numeric = (params) => {
    return convert24HourTo12Hour(getHour24Numeric(params));
};
/**
 * Returns a two-digit string representation of the hour in 12-hour time: 01, 02, ..., 12
 * @hidden
 */
export const getHour12TwoDigit = (params) => {
    const hour = getHour12Numeric(params);
    return padNumberToLength(hour, 2);
};
//# sourceMappingURL=hour.js.map